import script from "./JobLogModal.vue?vue&type=script&setup=true&lang=js"
export * from "./JobLogModal.vue?vue&type=script&setup=true&lang=js"

import "./JobLogModal.vue?vue&type=style&index=0&id=bdafcbda&scoped=true&lang=css"

import exportComponent from "/home/borg/github/Heborg/booking-web/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdafcbda"]])

export default __exports__